import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class AlertService {
    private subject = new Subject<any>();
    private keepAfterRouteChange = false;

    constructor(private router: Router, private toastr: ToastrService) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                } else {
                    // clear alert message
                    this.clear();
                }
            }
        });
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    success(message: string, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({ type: 'success', text: message });

        setTimeout(() => {
            this.clear();
        }, 3000);
    }

    error(message: string, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({ type: 'error', text: message });

        setTimeout(() => {
            this.clear();
        }, 3000);
    }

    clear() {
        // clear by calling subject.next() without parameters
        this.subject.next(null);
    }

    showSuccess(message: string) {
        this.toastr.clear();
        this.toastr.success(message);
    }

    showError(message: string, noClear: boolean = false) {
        if (noClear) {
            this.toastr.error(message);
            setTimeout(() => {
                this.clear();
            }, 4000);
        } else {
            this.toastr.clear();
            this.toastr.error(message);
        }

    }

    showWarning(message: string) {
        this.toastr.warning(message, '', { disableTimeOut: true, closeButton: true });
    }
}